<microsec-loading-overlay [isLoading]="!!isLoading">
  <microsec-card [isBordered]="true">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <div class="flex items-begin gap-4">
          <i class="fa fa-building text-5xl mt-2"></i>
          <div class="flex flex-col gap-1">
            <label class="text-lg font-bold">Organization {{ organization?.name || '' }}</label>
            <div class="flex flex-wrap">
              <label class="text-grey">Organization ID: {{ organization?.id || '' }}</label>
            </div>
            @if (!!organization?.address) {
              <div class="flex flex-wrap">
                <label class="text-grey">Address: {{ organization.address }}</label>
              </div>
            }
            @if (!!organization?.telephone_number) {
              <div class="flex flex-wrap">
                <label class="text-grey">Phone Number: {{ organization.telephone_number }}</label>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-span-12">
        <div class="flex flex-col gap-4 w-full">
          @if (permissions[USER_ROLE.ADMIN]) {
            <div class="flex text-white">
              <div class="flex" [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                <p-button
                  severity="primary"
                  [style]="{ 'text-transform': 'none' }"
                  [rounded]="true"
                  label="Edit Organization Details"
                  [disabled]="!isValidLicense()"
                  (onClick)="openLink()" />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </microsec-card>
</microsec-loading-overlay>
